import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const USER_STATUS_CLASSES = {
    completed:            { text: 'text-colorsStatusBadges-completed-text',          bg: 'bg-colorsStatusBadges-completed-bg' },
    'repair-in-progress': { text: 'text-colorsStatusBadges-repair-in-progress-text', bg: 'bg-colorsStatusBadges-repair-in-progress-bg' },
    canceled:             { text: 'text-colorsStatusBadges-canceled-text',           bg: 'bg-colorsStatusBadges-canceled-bg' },
    'on-hold':            { text: 'text-colorsStatusBadges-on-hold-text',            bg: 'bg-colorsStatusBadges-on-hold-bg' },
}

const UserStatusBadge = ({ status }) => {
    const getColorClasses = () => {
        switch (status) {
            case 'Activated': return USER_STATUS_CLASSES['completed']
            case 'You':       return USER_STATUS_CLASSES['repair-in-progress']
            case 'Invited':   return USER_STATUS_CLASSES['canceled']
            default:          return USER_STATUS_CLASSES['on-hold']
        }
    }
    const { text: textClass, bg: bgClass } = getColorClasses()

    return (
        <div className="h-10 flex items-center">
            <span
                className={clsx(
                    'py-1 px-3 rounded-xl font-medium text-xs text-center flex items-center leading-3.75',
                    textClass,
                    bgClass,
                )}
            >
                {status}
            </span>
        </div>
    )
}

UserStatusBadge.propTypes = {
    status: PropTypes.string,
}

export default UserStatusBadge
